<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/AD0mtz/tc-custom/9780292773400.jpg?1705766095704" alt="This image is the cover for the book Trillin on Texas, Bridwell Texas History Series"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Trillin on Texas, Bridwell Texas History Series
      </h1>
      <p class="bookDescription body article font2">
        <b>Articles and comic verse about the Lone Star State from the Thurber Prize winner: “</b><b>What’s not to love?” —<i>Texas Monthly</i></b><br/>  <br/> Whether reporting for the <i>New Yorker</i>, penning comic verse and political commentary, or writing his memoirs, Calvin Trillin has bumped into Texas again and again. He insists it’s not by design—“there has simply been a lot going on in Texas.” Astute readers will note, however, that Trillin’s family immigrated to America through the port of Galveston, and, after reading this book, many will believe the Lone Star State has somehow imprinted itself on his imagination.<br/>  <br/><i>Trillin on Texas</i> gathers some of his best writing on subjects near to his heart—politics, true crime, food, and rare books among them—that also have a Texas connection. Indulging his penchant for making “snide and underhanded jokes about respectable public officials,” he offers his signature sardonic take on the Bush dynasty and their tendency toward fractured syntax; a faux but quite believable LBJ speech; and wry portraits of assorted Texas county judges, small town sheriffs, and Houston immigration lawyers. He takes us on a pilgrimage to the barbecue joint that <i>Texas Monthly</i> named the best in Texas, and describes scouting for books with Larry McMurtry. He tells the stories of two teenagers who dug up half a million dollars in an ice chest, and of rare book dealer Johnny Jenkins, who was found floating in the Colorado River with a bullet wound in the back of his head. And he recounts how redneck movie reviewer “Joe Bob Briggs” fueled a war between Dallas’s daily newspapers and pays tribute to two courageous Texas women who spoke truth to power: Molly Ivins and Sissy Farenthold. Sure to entertain both Texans and non-Texans, <i>Trillin on Texas</i> proves again that Trillin is one of America’s shrewdest and wittiest observers.
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Calvin Trillin
      </h2>
      
      <p class="authorDescription body article">CALVIN TRILLIN has been a staff writer for the New Yorker since 1963. Since 1990, he has also been the Nation’s “deadline poet.” He is the author of twenty-seven books.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      University of Texas Press
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?abe33ff0